<template>
	<dp-modal :active="exportActive" :title="$t('title.buildExport')" @close="showExport(false)">
		<label v-t="'action.buildCopyExplanation'" label-for="build-import-url" />
		<textarea
			id="build-export-url"
			ref="buildUrl"
			:value="url"
			class="textarea has-text-tiny"
			type="url"
			readonly
			@focus="$event.target.select()" />
		<button
			slot="footer"
			v-t="'action.buildCopy'"
			class="button is-primary"
			@click="copyBuild" />
	</dp-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	computed: {
		...mapState(['exportActive']),
		url() { return this.exportActive ? window.location.href : ''; },
	},
	methods: {
		...mapActions(['showExport']),
		copyBuild() {
			this.$refs.buildUrl.select();
			document.execCommand('copy');
		},
	},
};
</script>

<style scoped>
.textarea.has-text-tiny {
	font-size: 0.75rem;
}
</style>
